import {
  LangChangeEvent,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { takeUntil } from 'rxjs/operators';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CUSTOM_DATE_FORMATS, CustomDatePickerAdapter } from './date-adapter';
import { BaseComponent } from '../core';

@NgModule({
  imports: [TranslateModule.forChild()],
  providers: [
    MatDatepickerModule,
    { provide: DateAdapter, useClass: CustomDatePickerAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
  ],
})
export class DateAdapterModule extends BaseComponent {
  constructor(
    private translateService: TranslateService,
    private matDateAdapter: DateAdapter<any>
  ) {
    super();

    // DateAdapter<> must be used in commons module because of lazy loading module issue
    // see: https://github.com/angular/components/issues/12891#issuecomment-786757412

    if (this.translateService.currentLang) {
      this.matDateAdapter.setLocale(this.translateService.currentLang);
    }

    this.translateService.onLangChange
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((event: LangChangeEvent) => {
        if (event.lang) {
          this.matDateAdapter.setLocale(event.lang);
        }
      });
  }
}
